import { render } from "./OTPEmailForm.vue?vue&type=template&id=744ec148"
import script from "./OTPEmailForm.vue?vue&type=script&lang=js"
export * from "./OTPEmailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__